import axios from "axios";

export const convertToKn = (byte) => Math.round(byte / 1024);

const imageTypes = ["jpeg", "png", "jpg", "webp"];
const audioTypes = ["mp3"];
const videoTypes = ["mkv", "mp4", "m4v", "mpeg","mov"];
const docTypes = ["ppt", "pptx", "docx", "pdf", "zip", "csv", "xls", "xlsx"];

const fileType = [...imageTypes, ...audioTypes, ...videoTypes, ...docTypes];

// map type groups
const typeMap = {
  image: imageTypes,
  video: videoTypes,
  audio: audioTypes,
  doc: docTypes,
};

const getType = (type) => {
  const name = type.split(".");
  return name[name.length - 1];
};

export const validateFile = (file, validateOnly = []) => {
  if (!file) return false;

  const type = getType(file.name || file.type);

  // fallback: allow all supported types
  if (!validateOnly.length) {
    return fileType.includes(type);
  }

  // check if file matches ANY allowed category
  return validateOnly.some((category) => {
    const allowedTypes = typeMap[category];
    return allowedTypes?.includes(type.toLowerCase());
  });
};

export const validateThumbnail = (file) => {
  if (!validateFile(file, ["image"])) return false;
  return convertToKn(file.size) < 2 * 1024;
};

export function removeFirstSlash(pathname) {
  if (!pathname) return "";
  return pathname.replace("/", "");
}

export function getLinkPath(link) {
  try {
    return decodeURIComponent(new URL(link).pathname);
  } catch (err) {
    console.log(err.message);
    return undefined;
  }
}

export async function getSignedURL(data) {
  const res = await axios.post(
    `${process.env.REACT_APP_ORIGIN}/api/v1/files/signed-url`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
        token: window.localStorage.getItem("authToken"),
      },
    },
  );
  return res.data?.data?.url;
}

export async function uploadFileToS3(file, signedURL, onProgress) {
  const response = await axios.put(signedURL, file, {
    headers: {
      "Content-Type": file.type,
    },
    onUploadProgress: (progressEvent) => {
      const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total,
      );
      if (onProgress) {
        onProgress(percentCompleted);
      }
    },
  });

  console.log("Upload success:", response.status);
}
